export const checkSubscription = async (email) => {
    try {
      const res = await fetch("https://dgg5joe5f9.execute-api.us-east-1.amazonaws.com/prod/check-subscription", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
  
      const data = await res.json();
      return {
        subscribed: data.subscribed || false,
        subscriptionId: data.subscriptionId || null,
      };
    } catch (err) {
      console.error("Error checking subscription:", err);
      return {
        subscribed: false,
        subscriptionId: null,
      };
    }
  };
  